
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_ae8n8_97",
  "has-items": "awsui_has-items_dm8gx_ae8n8_131",
  "no-padding": "awsui_no-padding_dm8gx_ae8n8_131",
  "dismiss-button": "awsui_dismiss-button_dm8gx_ae8n8_135",
  "token": "awsui_token_dm8gx_ae8n8_177",
  "token-box": "awsui_token-box_dm8gx_ae8n8_184",
  "token-box-error": "awsui_token-box-error_dm8gx_ae8n8_203",
  "token-box-disabled": "awsui_token-box-disabled_dm8gx_ae8n8_214"
};
  